import { captureSentryMessage } from '@shared/sentry';

export function startHandlingInstallation(): void {
  chrome.runtime.onInstalled.addListener(async function (details) {
    captureSentryMessage(`Installation`, details);
  });
}
